export default [
    {
        path: 'listagem-exames-agendados',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-listagem-exames-agendados' */
            '@/views/exame-imagem/listagem-exame-agendado/Index'
        ),
        redirect: 'listagem-exames-agendados/index',
        children: [
            {
                name: 'exame-imagem-listagem-exames-agendados-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-listagem-exames-agendados' */
                    '@/views/exame-imagem/listagem-exame-agendado/List'
                ),
            },
        ]
    }
]